import React from "react";
import imgSuccess from "assets/images/success.png";
import {
    Row, Col,
    Card,
    CardBody,
    Modal,
    ModalBody,
    ModalHeader
} from "reactstrap";
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from "react-redux";

const SuccessModal = ({ modal, onClick, id }) => {
    const { t } = useTranslation();
    const AuthData = useSelector(state => state.Auth)

    return (
        <Modal isOpen={modal} className="successModal"  >
            <ModalBody style={{ background: "white" }}>
                <Card  >
                    <CardBody className=" p-0 m-0">
                        <Row  className={`${AuthData.lang!="ar" ? "mb-4 px-2  d-flex flex-row-reverse":" mb-4 px-2 "}`}  >
                        <Col md={1}><div onClick={onClick} style={{ curser: "pointer" }} className="h5 m-0 p-0 ">x</div></Col>

                        <Col md={11}
                        className={`${AuthData.lang!="ar" ? "h5 m-0 p-0 font-size-15 d-flex justify-content-start":" h5 m-0 p-0 font-size-15 d-flex justify-content-end"}`}
                        >{id ? t("Listing Update Successfully") : t("Listing created Successfully")}</Col>


                        </Row>
                        <Row className="d-flex justify-content-center mb-4 text-center " style={{ marginTop: "60px" }}>
                            <Col md={8} className="font-size-15">
                                {id ? 
                                    t("Your listing updated successfully Wait until admin approval")
                                    :
                                    t("Your new listing successfully Submitted Wait until admin approval")
                                }
                            </Col>
                        </Row>
                        <Row className="text-center">
                            <button className="btn btn-dark .text-light w-100 mt-4 font-size-15" onClick={onClick}>{t("home")}</button>
                        </Row>
                    </CardBody>
                </Card>
            </ModalBody>
        </Modal>
    )
}

export default SuccessModal